import { render, staticRenderFns } from "./levelGroup.vue?vue&type=template&id=52489410&scoped=true"
import script from "./levelGroup.vue?vue&type=script&lang=js"
export * from "./levelGroup.vue?vue&type=script&lang=js"
import style0 from "./levelGroup.vue?vue&type=style&index=0&id=52489410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52489410",
  null
  
)

export default component.exports